import React, { useState } from 'react'

const CONFIGURATOR_URL = window.location.origin

const code1 = `/* ============================================================
   KROK 1: Custom CSS — wklej w ustawieniach motywu / wtyczki
   Działa TYLKO na tej jednej podstronie z konfiguratorem
   ============================================================ */

/* Blokuj scroll strony tylko tam gdzie jest konfigurator */
body.strona-konfigurator {
  overflow: hidden !important;
}

/* Ukryj footer — konfigurator zajmuje cały ekran */
body.strona-konfigurator footer,
body.strona-konfigurator .footer,
body.strona-konfigurator .site-footer {
  display: none !important;
}

/* Usuń padding z obszaru treści */
body.strona-konfigurator main,
body.strona-konfigurator .site-content,
body.strona-konfigurator .entry-content,
body.strona-konfigurator .page-content {
  padding: 0 !important;
  margin: 0 !important;
}

/* Kontener iframe — od nagłówka do dołu ekranu */
.konfigurator-wrapper {
  position: fixed;
  top: 80px;     /* ← zmień na wysokość Twojego nagłówka (w px) */
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 10;
}

.konfigurator-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}`

const code2 = `<!-- ============================================================
   KROK 2: HTML — wklej w treści podstrony (blok HTML / shortcode)
   ============================================================ -->

<div class="konfigurator-wrapper">
  <iframe
    src="ADRES_KONFIGURATORA"
    title="Konfigurator ogrodzeń Kost-Bet"
    allow="fullscreen"
    loading="lazy"
  ></iframe>
</div>`

const code3 = `/* ============================================================
   WORDPRESS: Jak dodać klasę "strona-konfigurator" do <body>
   tylko na tej jednej stronie?
   ============================================================ */

/* OPCJA A — wtyczka: zainstaluj "Body Class" lub 
   "Per Page Body Class" i wpisz: strona-konfigurator  */

/* OPCJA B — functions.php motywu: */
add_filter('body_class', function($classes) {
  if (is_page('konfigurator')) {   /* ← slug Twojej strony */
    $classes[] = 'strona-konfigurator';
  }
  return $classes;
});

/* OPCJA C — jeśli używasz Elementor / Divi / Oxygen:
   znajdź opcję "Body CSS Class" w ustawieniach strony
   i wpisz: strona-konfigurator                          */`

const IframeTestPage: React.FC = () => {
  const [showCode, setShowCode] = useState(false)
  const [copied, setCopied] = useState<string | null>(null)

  const copy = (key: string, text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key)
      setTimeout(() => setCopied(null), 2000)
    })
  }

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>

      {/* ─── NAGŁÓWEK ─── */}
      <div style={{
        height: '56px',
        flexShrink: 0,
        background: '#0f172a',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        zIndex: 50,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            background: 'linear-gradient(135deg,#ef4444,#dc2626)',
            borderRadius: '8px',
            width: '30px', height: '30px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '15px',
            boxShadow: '0 0 14px rgba(239,68,68,0.4)',
          }}>🏗️</div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#f1f5f9', lineHeight: 1.2 }}>
              Kost-Bet — Demonstracja poprawnego iframe
            </div>
            <div style={{ fontSize: '11px', color: '#64748b', lineHeight: 1.3 }}>
              Konfigurator poniżej = pełny ekran, zero scrollowania wewnętrznego ✅
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            onClick={() => setShowCode(!showCode)}
            style={{
              padding: '6px 14px',
              borderRadius: '8px',
              border: showCode ? '1px solid #3b82f6' : '1px solid rgba(255,255,255,0.15)',
              background: showCode ? 'rgba(59,130,246,0.2)' : 'rgba(255,255,255,0.06)',
              color: showCode ? '#93c5fd' : '#cbd5e1',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
            }}
          >
            {showCode ? '✕ Zamknij instrukcję' : '📋 Instrukcja dla dewelopera'}
          </button>
        </div>
      </div>

      {/* ─── PANEL Z KODEM ─── */}
      {showCode && (
        <div style={{
          flexShrink: 0,
          background: '#060d1a',
          borderBottom: '2px solid #1e3a5f',
          maxHeight: '55vh',
          overflowY: 'auto',
          padding: '20px 24px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}>
          {/* Info */}
          <div style={{
            background: 'rgba(59,130,246,0.08)',
            border: '1px solid rgba(59,130,246,0.25)',
            borderRadius: '10px',
            padding: '12px 16px',
            fontSize: '13px',
            color: '#93c5fd',
            lineHeight: 1.6,
          }}>
            <strong style={{ color: '#60a5fa' }}>💡 Jak to działa:</strong> konfigurator to aplikacja pełnoekranowa.
            Żeby działał bez scrollowania w iframe, musi zajmować cały ekran pod nagłówkiem strony.
            CSS poniżej <strong>dotyczy tylko tej jednej podstrony</strong> — nie psuje reszty strony.
          </div>

          <CodeBlock
            label="KROK 1 — Custom CSS (wklej w ustawieniach motywu)"
            badge="CSS"
            badgeColor="#f59e0b"
            code={code1}
            onCopy={() => copy('css', code1)}
            copied={copied === 'css'}
          />
          <CodeBlock
            label="KROK 2 — HTML w treści strony (blok HTML / shortcode)"
            badge="HTML"
            badgeColor="#22c55e"
            code={code2}
            onCopy={() => copy('html', code2)}
            copied={copied === 'html'}
          />
          <CodeBlock
            label="WordPress — jak dodać klasę do body tej strony"
            badge="WordPress"
            badgeColor="#3b82f6"
            code={code3}
            onCopy={() => copy('wp', code3)}
            copied={copied === 'wp'}
          />
        </div>
      )}

      {/* ─── IFRAME ─── */}
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
        <div style={{
          position: 'absolute',
          top: 8, left: 10,
          background: 'rgba(34,197,94,0.85)',
          borderRadius: '5px',
          padding: '2px 9px',
          fontSize: '11px',
          color: 'white',
          fontWeight: 600,
          zIndex: 20,
          pointerEvents: 'none',
        }}>
          ← iframe · brak scrollowania wewnętrznego
        </div>
        <iframe
          src={CONFIGURATOR_URL}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          title="Konfigurator ogrodzeń Kost-Bet"
          allow="fullscreen"
        />
      </div>
    </div>
  )
}

interface CodeBlockProps {
  label: string
  badge: string
  badgeColor: string
  code: string
  onCopy: () => void
  copied: boolean
}

const CodeBlock: React.FC<CodeBlockProps> = ({ label, badge, badgeColor, code, onCopy, copied }) => (
  <div style={{
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: '12px',
    overflow: 'hidden',
  }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '9px 14px',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      background: 'rgba(255,255,255,0.02)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{
          background: `${badgeColor}22`,
          border: `1px solid ${badgeColor}55`,
          color: badgeColor,
          borderRadius: '6px',
          padding: '1px 8px',
          fontSize: '11px',
          fontWeight: 700,
        }}>{badge}</span>
        <span style={{ fontSize: '13px', fontWeight: 600, color: '#cbd5e1' }}>{label}</span>
      </div>
      <button
        onClick={onCopy}
        style={{
          padding: '4px 14px',
          borderRadius: '6px',
          border: '1px solid rgba(255,255,255,0.1)',
          background: copied ? 'rgba(34,197,94,0.2)' : 'rgba(255,255,255,0.06)',
          color: copied ? '#4ade80' : '#94a3b8',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {copied ? '✓ Skopiowano!' : 'Kopiuj'}
      </button>
    </div>
    <pre style={{
      margin: 0,
      padding: '14px 18px',
      fontSize: '12px',
      lineHeight: 1.75,
      color: '#94a3b8',
      fontFamily: "'JetBrains Mono','Fira Code',monospace",
      overflowX: 'auto',
      whiteSpace: 'pre',
    }}>
      <code style={{ color: '#e2e8f0' }}>{code}</code>
    </pre>
  </div>
)

export default IframeTestPage
